import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import Clients from "@/components/Clients";
import Gallery from "@/components/Gallery";
import EnquiryForm from "@/components/EnquiryForm";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ChatWidget from "@/components/ChatWidget";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#09090b] min-h-screen text-white" data-testid="app-root">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <Clients />
        <Gallery />
        <EnquiryForm />
      </main>
      <Footer />
      <ChatWidget />
      <WhatsAppButton />
      <Toaster
        theme="dark"
        toastOptions={{
          style: {
            background: "#121215",
            border: "1px solid rgba(212,175,55,0.35)",
            color: "#f3e5ab",
          },
        }}
      />
    </div>
  );
}

export default App;
